
import React, { useState } from 'react';

import { 
  ModelBase, 
} from "@models";
import { 
  LootTable, 
} from "@dndModels";

import API from "@utilities/smart_api";

import ModelBaseInput from "@dndComponents/ModelBaseInput";

const api = API.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function LootTableEdit({ obj: param_obj }: Props) {
  const [obj, setObj] = useState<LootTable>(param_obj instanceof LootTable ? param_obj : api.applyWorkingOn(new LootTable()));
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);

  return (
    <ModelBaseInput 
      obj={obj}
      disabled={disabled}
      onChange={(changed: ModelBase) => {
        if (changed instanceof LootTable) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
        }
      }}
    />
  );
}